import { createContext, useContext, useState, useEffect } from "react";
import { translations } from "../lib/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("tubmix_lang") || "fr");

  useEffect(() => {
    localStorage.setItem("tubmix_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const dict = translations[lang] || translations.fr;
    const val = path.split(".").reduce((o, k) => (o ? o[k] : undefined), dict);
    if (val !== undefined) return val;
    const fb = path.split(".").reduce((o, k) => (o ? o[k] : undefined), translations.fr);
    return fb !== undefined ? fb : path;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
